
class RequestHandler {
    constructor(request) {
        this._request = request;
        this._data = request.data;
        this._timerId = null;
        this._waitResponseCallback = null;
        this._retryCounter = 0;
    }
    
    get data() {
        return this._data;
    }

    get id() {
        return this._data.req_id;
    }

    isMaxRetryCountReached() {
        return this._retryCounter >= this._request.maxRetryCount;
    }

    increaseRetryCounter() {
        this._retryCounter++;
    }

    onReceiveResponse(data) {
        if (this._waitResponseCallback) {
            this.stopTimeout();
            this._waitResponseCallback(data);
        }
    }

    async waitResponse() {
        let requestHandler = this;

        let promise = new Promise((resolve, reject) => {
            requestHandler._waitResponseCallback = resolve;
        });
        
        this._timerId = setTimeout(function() {
            requestHandler._waitResponseCallback(null);
        }, this._request.timeoutMs);

        let response = await promise;
        this._waitResponseCallback = null;
        if (response === null || !this._request.checkResponse(response))
            return null;
        
        return response;
    }

    startTimeout(onTimeoutCallback, ms) {
        this._timerId = setTimeout(onTimeoutCallback, ms);
    }
    stopTimeout() {
        clearTimeout(this._timerId);
    }
}

export default RequestHandler;